import { useEffect, useState } from 'react';
import { ClipboardCheck } from 'lucide-react';
import { useStore } from '../store';
import { leadGenApi } from '../services/leadGenApi';
import { offenerAnrufText } from '../store/offenerAnrufSlice';

// ADR 0373 (Riegel C): solange der eigene letzte Anruf von heute kein Ergebnis hat, steht dieser Streifen oben
// („Erst Ergebnis zu Philipp Braun (pflegehilfe.org)“) und führt direkt in das Abschluss-Fenster dieses Anrufs.
// Gewählt wird dabei nicht neu und nichts doppelt gezählt (`rueckruf-annehmen` mit `nachtrag`). Der Server sperrt das
// Wählen ohnehin; der Streifen ist der Ausweg. Ist das Cockpit offen (auch minimiert), zeigt es selbst den Anruf.
export function OffenerAnrufStreifen() {
  const offen = useStore((s) => s.offenerAnruf);
  const callViewOpen = useStore((s) => s.callViewOpen);
  const laden = useStore((s) => s.ladeOffenenAnruf);
  const letzterAbschluss = useStore((s) => s.letzterAbschluss);
  const [laeuft, setLaeuft] = useState(false);
  const [fehler, setFehler] = useState<string | null>(null);

  // Neu lesen: beim Start, beim Zurückkommen in den Tab, wenn ein Cockpit auf- oder zugeht und nach jedem Speichern.
  useEffect(() => { void laden(); }, [laden, callViewOpen, letzterAbschluss]);
  useEffect(() => {
    const h = () => { void laden(); };
    window.addEventListener('focus', h);
    window.addEventListener('arbeitsliste-schritt', h);
    return () => { window.removeEventListener('focus', h); window.removeEventListener('arbeitsliste-schritt', h); };
  }, [laden]);

  if (!offen || callViewOpen) return null;

  const eintragen = async () => {
    setLaeuft(true); setFehler(null);
    try {
      const res = await leadGenApi.rueckrufAnnehmen(offen.lead_id, offen.phone, undefined, offen.person_key, true);
      const s = useStore.getState();
      if (!s.leads.some((l) => l.id === res.lead.id)) useStore.setState((st) => ({ leads: [res.lead, ...st.leads] }));
      s.setzeNachtrag(true);
      s.startCall(res.lead, undefined, res.dial ?? null);
    } catch (e) {
      setFehler(e instanceof Error ? e.message : 'Konnte das Cockpit nicht öffnen.');
    } finally {
      setLaeuft(false);
    }
  };

  return (
    <div className="fixed top-3 left-1/2 -translate-x-1/2 z-[60] flex items-center gap-3 rounded-lg border
                    border-amber-500/50 bg-bg-secondary px-3 py-2 text-sm text-amber-200 shadow-lg"
         data-testid="offener-anruf">
      <ClipboardCheck size={15} className="shrink-0" />
      <span>{offenerAnrufText(offen)}</span>
      <button onClick={() => void eintragen()} disabled={laeuft}
              className="px-2 py-1 rounded-lg border border-border-primary bg-bg-tertiary text-xs font-semibold
                         text-text-main hover:bg-bg-elevated disabled:opacity-40">
        Ergebnis eintragen
      </button>
      {fehler && <span className="text-rose-300 text-xs">{fehler}</span>}
    </div>
  );
}
